import {
  Button,
  Modal,
  Box,
  TextField,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import {
  footerButtonWidth,
  cancelButtonStyles,
  registerPatientButtonStyles,
} from "../../common/commonStyles";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import Divider from "@mui/material/Divider";

const UserCreationForm = ({
  open,
  handleClose,
  formData,
  handleInputChange,
  handleCreateUser,
  roles,
}) => {
  return (
    <div>
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            flexGrow: 1,
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            padding: "15px 25px 15px 25px",
            width: "800px",
            maxWidth: "800px",
            maxHeight: "600px",
            overflowY: "auto",
          }}
        >
          <IconButton
            onClick={handleClose}
            sx={{
              position: "absolute",
              top: 10,
              right: 8,
            }}
          >
            <CloseIcon />
          </IconButton>

          <Grid container>
            <Grid item xs={12}>
              <h3 className="form-title">User Creation Form</h3>
            </Grid>
          </Grid>
          <Divider sx={{ marginBottom: "20px" }} />
          <Grid container spacing={2} sx={{ marginBottom: "20px" }}>
            <Grid size={5}>
              <TextField
                required
                fullWidth
                margin="normal"
                label="Name"
                name="name"
                size="small"
                value={formData?.name}
                onChange={handleInputChange}
                autoComplete="off"
                className="custom-textfield"
              />
            </Grid>
            <Grid size={4}>
              <TextField
                required
                fullWidth
                margin="normal"
                label="Email"
                name="email"
                size="small"
                value={formData?.email}
                onChange={handleInputChange}
                autoComplete="off"
                className="custom-textfield"
              />
            </Grid>
            <Grid size={3}>
              <TextField
                required
                margin="normal"
                label="Phone Number"
                name="phone_number"
                size="small"
                value={formData?.phone_number}
                onChange={handleInputChange}
                autoComplete="off"
                className="custom-textfield"
              />
            </Grid>
            <Grid size={5}>
              <FormControl fullWidth sx={{ minWidth: 120 }} size="small">
                <InputLabel className="custom-selectfield-label">
                  Role
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  label="Role"
                  name="role"
                  size="small"
                  value={formData?.role}
                  onChange={handleInputChange}
                  className="custom-selectfield"
                >
                  {roles?.map((step, index) => (
                    <MenuItem value={step}>{step}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid size={7}>
              <TextField
                required
                fullWidth
                margin="normal"
                multiline
                maxRows={4}
                label="Address"
                name="address"
                value={formData?.address}
                onChange={handleInputChange}
                autoComplete="off"
                className="custom-textfield"
              />
            </Grid>
          </Grid>
          <div className="register_btn">
            <Button
              variant="contained"
              sx={[registerPatientButtonStyles, footerButtonWidth]}
              size="small"
              onClick={() => {
                handleCreateUser();
              }}
            >
              Create
            </Button>
            <Button
              variant="contained"
              sx={[cancelButtonStyles, footerButtonWidth]}
              size="small"
              onClick={() => {
                handleClose();
              }}
            >
              Cancel
            </Button>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default UserCreationForm;
